module.exports = __webpack_public_path__ + "img/zkzy-white.f460c9ee.png";